import * as React from 'react';
export const modalWindowSvg = React.forwardRef(function modalWindowSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13 1.5a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H3l-.154-.004a3 3 0 0 1-2.842-2.842L0 11.5v-7a3 3 0 0 1 3-3h10ZM3 3a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 3 13h10a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 13 3H3Zm9.3 1.25a.95.95 0 0 1 .95.95v5.6a.95.95 0 0 1-.95.95H6.7a.95.95 0 0 1-.95-.95V5.2a.95.95 0 0 1 .95-.95h5.6Zm-5.05 6h4.5v-4.5h-4.5v4.5Z',
    }),
  );
});
modalWindowSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var modalWindow = {
  category: 'icon',
  colorable: true,
  name: 'modalWindow',
  svg: modalWindowSvg,
};
